import {useCallback, useState} from 'react'

export type UseBinaryStateResult = [
  boolean,
  set: VoidFunction,
  reset: VoidFunction,
  toggle: VoidFunction,
]

function useBinaryState(initialState = false): UseBinaryStateResult {
  const [state, setState] = useState<boolean>(initialState)
  const set = useCallback(() => setState(true), [])
  const reset = useCallback(() => setState(false), [])
  const toggle = useCallback(() => setState(prevState => !prevState), [])
  return [state, set, reset, toggle]
}

export default useBinaryState
